<div class="bmc-syncdata-import-step30">
    <label class="bmc-syncdata-import-step30__higher-text">{{ 'SYNC_DATA.IMPORT_FINISHED' | translate}}</label>
    <label class="bmc-syncdata-import-step30__lower-text">{{ 'SYNC_DATA.DATA_IMPORTED' | translate}}</label>
</div> 
